export const getApiBaseUrl = (): string => {
  if (typeof window !== 'undefined') {
    const runtimeUrl = (window as any).__ENV__?.NEXT_PUBLIC_API_URL;
    if (runtimeUrl && typeof runtimeUrl === 'string' && runtimeUrl !== '__NEXT_PUBLIC_API_URL__' && !runtimeUrl.startsWith('__')) {
      const trimmed = runtimeUrl.trim().replace(/\/+$/, '');
      if (trimmed) return trimmed;
    }
    if (typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_API_URL) {
      const trimmed = String(process.env.NEXT_PUBLIC_API_URL).trim().replace(/\/+$/, '');
      if (trimmed) return trimmed;
    }
    return '/api';
  } else {
    // Server-side execution (RSC / SSR / rewrites config context)
    const backendUrl = process.env.BACKEND_API_URL;
    if (backendUrl) return String(backendUrl).trim().replace(/\/+$/, '');

    const publicUrl = process.env.NEXT_PUBLIC_API_URL;
    if (publicUrl && publicUrl !== '/api' && String(publicUrl).trim().startsWith('http')) {
      return String(publicUrl).trim().replace(/\/+$/, '');
    }

    return process.env.NODE_ENV === 'production'
      ? 'https://prod-legacy-global-bank-crm-backend-git-844417757492.asia-southeast1.run.app/api'
      : 'http://localhost:3001/api';
  }
};


